// frontend/src/pages/admin/AdminTarification.jsx
// Regroupe, sous une seule entrée de nav et en onglets internes, les trois
// pages autrefois séparées : Profils tarifaires, Périodes tarifaires et
// Moyens de paiement — elles concernent toutes la tarification et n'ont
// pas besoin chacune de leur propre ligne dans le menu.
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../utils/auth';
import { Tag, CreditCard } from 'lucide-react';
import AdminPriceProfiles from './AdminPriceProfiles';
import AdminPricingPeriods from './AdminPricingPeriods';
import AdminPaymentMethods from './AdminPaymentMethods';

const TABS = [
  { key:'profils',   label:'Profils tarifaires',  icon:Tag,        perm:'admin.pricing', min:'admin',   Comp:AdminPriceProfiles },
  { key:'periodes',  label:'Périodes tarifaires', icon:Tag,        perm:'admin.pricing', min:'manager', Comp:AdminPricingPeriods },
  { key:'paiements', label:'Moyens de paiement',  icon:CreditCard, perm:'payments.manage', min:'admin', Comp:AdminPaymentMethods },
];

export default function AdminTarification() {
  const { can } = useAuth();
  const [searchParams] = useSearchParams();

  const visibleTabs = TABS.filter(t => (!t.perm || can(t.perm)) && (!t.min || can(t.min)));

  const initialTab = searchParams.get('tab');
  const [tab, setTab] = useState(
    visibleTabs.find(t => t.key === initialTab)?.key || visibleTabs[0]?.key
  );

  if (visibleTabs.length === 0) {
    return <div className="page-body"><div className="empty-state card"><p>Accès non autorisé</p></div></div>;
  }

  const active = visibleTabs.find(t => t.key === tab) || visibleTabs[0];
  const ActiveComp = active.Comp;

  return (
    <>
      <div className="page-header">
        <div>
          <h2>Tarification</h2>
          <p>Profils, périodes et moyens de paiement</p>
        </div>
      </div>

      <div className="page-body">
        {visibleTabs.length > 1 && (
          <div style={{ display:'flex', gap:8, marginBottom:18, flexWrap:'wrap' }}>
            {visibleTabs.map(t => (
              <button key={t.key} type="button"
                className={`btn btn-sm ${tab === t.key ? 'btn-primary' : 'btn-secondary'}`}
                onClick={() => setTab(t.key)}>
                <t.icon size={13}/> {t.label}
              </button>
            ))}
          </div>
        )}

        <ActiveComp embedded/>
      </div>
    </>
  );
}
